/**
 * Safely extract a human-readable error message from an API error response.
 * Handles FastAPI string detail AND Pydantic validation error arrays.
 */
export function getApiErrorMessage(error, fallback = 'Une erreur est survenue') {
  const detail = error?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map(e => (typeof e === 'object' ? e.msg || JSON.stringify(e) : String(e))).join(', ') || fallback;
  }
  if (typeof detail === 'object') return detail.msg || detail.message || JSON.stringify(detail);
  return String(detail);
}
